/**
 * @generated SignedSource<<c3ff88ac1f066c43a33c29d9f5471a48>>
 * @relayHash 588565a442c5a95cee3a49cef1ce7f05
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 588565a442c5a95cee3a49cef1ce7f05

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteMedicalReportAttachmentInput = {
  id: string;
};
export type chDeleteMedicalReportMutation$variables = {
  connections: ReadonlyArray<string>;
  input: Ch_deleteMedicalReportAttachmentInput;
};
export type chDeleteMedicalReportMutation$data = {
  readonly deleteMedicalReport: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly medicalReportAttachment: {
      readonly id: string;
    } | null;
  };
};
export type chDeleteMedicalReportMutation = {
  response: chDeleteMedicalReportMutation$data;
  variables: chDeleteMedicalReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chDeleteMedicalReportMutation",
    "selections": [
      {
        "alias": "deleteMedicalReport",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteMedicalReportAttachmentPayload",
        "kind": "LinkedField",
        "name": "ch_deleteMedicalReportAttachment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MedicalReportAttachment",
            "kind": "LinkedField",
            "name": "medicalReportAttachment",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chDeleteMedicalReportMutation",
    "selections": [
      {
        "alias": "deleteMedicalReport",
        "args": (v2/*:: as any*/),
        "concreteType": "Ch_deleteMedicalReportAttachmentPayload",
        "kind": "LinkedField",
        "name": "ch_deleteMedicalReportAttachment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MedicalReportAttachment",
            "kind": "LinkedField",
            "name": "medicalReportAttachment",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "588565a442c5a95cee3a49cef1ce7f05",
    "metadata": {},
    "name": "chDeleteMedicalReportMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "21b22400203fe433e5620c79171eb09b";

export default node;
